






































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { Validator } from "vee-validate";
import {
  QuickSightReportManage
} from "@/admin/route-names";
import moment from "moment";
import { useQuickSightReportStore } from "@/admin/store/quickSightReport";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { UserPermission } from "@/shared/types";

@Component({
  components: {
    Button
  }
})
export default class EmployerRolePermissions extends Vue {
  $validator: Validator;

  quickSightReportStore = useQuickSightReportStore();
  rolePermissionsStore = useRolePermissionsStore();
  QuickSightReportManage = QuickSightReportManage;

  tableFields = [{ key: "reportName" }, { key: "dateCreated", label: "Date Added" }, { key: "reportCategoryName" }, { key: "reportType" }, { key: "isEnabled" }];

  formatDateString (date: string): string {
    return moment(date).format("MM/DD/YYYY");
  }

  mounted (): void {
    this.quickSightReportStore.getReports();
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityQuickSightReptEdit);
  }
}
